// extracted by mini-css-extract-plugin
export default {"account":"Account_account__JEl7g","form":"Account_form__UMQ2l"};